/*import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import asavaLogo from '../Assets/asava-logo.png';
import NavDropdown from 'react-bootstrap/NavDropdown';

function NavigationBar() {
  return (
    <>
      <Navbar sticky="top" bg="dark" expand="lg" data-bs-theme="dark">
        <Container style={{marginLeft:"0px"}}>
        <div>
          <img src={asavaLogo} height={"40px"} width={"40px"} 
            style={
              {borderRadius : '30px',
                display: 'flex' ,
                marginLeft : 'auto',
                marginRight: "5px"
              }} 
              alt= ""/>
        </div>
        <Navbar.Brand  href="/" style={{fontFamily:"Gill Sans",fontSize: "25px",color : "rgb(200,200,200)"}}>Asava Pharma</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/products">Products</Nav.Link>
            <NavDropdown
              id="nav-dropdown-dark-example"
              title="About"
              menuVariant="dark"
            >
              <NavDropdown.Item href="/overview">Overview</NavDropdown.Item>
              <NavDropdown.Item href="/corevalue">Core Value</NavDropdown.Item>
              <NavDropdown.Item href="/ourteam">Our Team</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/contactinfo">Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavigationBar;*/



import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import asavaLogo from '../Assets/asava-logo.png';
import NavDropdown from 'react-bootstrap/NavDropdown';
import "./navbar.css";

function NavigationBar() {
  return (
    <>
      <Navbar sticky="top" expand="lg" className="custom-navbar">
        <Container style={{ marginLeft: "0px" }}>

          <img
            src={asavaLogo}
            height="40px"
            width="40px"
            className="logo-img"
            alt="Asava Logo"
          />

          <Navbar.Brand href="/" className="navbar-brand-custom">
            Asava Pharma
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">

              <Nav.Link href="/products" className="nav-link-custom">
                Products
              </Nav.Link>

              <NavDropdown
                id="nav-dropdown-dark-example"
                title="About"
                className="dropdown-custom"
              >
                <NavDropdown.Item href="/overview">Overview</NavDropdown.Item>
                <NavDropdown.Item href="/corevalue">Core Value</NavDropdown.Item>
                <NavDropdown.Item href="/ourteam">Our Team</NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="/contactinfo" className="nav-link-custom">
                Contact Us
              </Nav.Link>

            </Nav>
          </Navbar.Collapse>

        </Container>
      </Navbar>
    </>
  );
}

export default NavigationBar;